import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { GiagoimfyAction } from 'src/actions/giagoimfy.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getGiagoimfyStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

const GiagoimfyLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedGiagoimfyIds, setSelectedGiagoimfyIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.giagoimfy);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(GiagoimfyAction.updateFilter(payload));
    dispatch(GiagoimfyAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedGiagoimfyIds;

    if (event.target.checked) {
      newSelectedGiagoimfyIds = items.map((giagoimfy) => giagoimfy.id);
    } else {
      newSelectedGiagoimfyIds = [];
    }

    setSelectedGiagoimfyIds(newSelectedGiagoimfyIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedGiagoimfyIds.indexOf(id);
    let newSelectedGiagoimfyIds = [];

    if (selectedIndex === -1) {
      newSelectedGiagoimfyIds = newSelectedGiagoimfyIds.concat(selectedGiagoimfyIds, id);
    } else if (selectedIndex === 0) {
      newSelectedGiagoimfyIds = newSelectedGiagoimfyIds.concat(selectedGiagoimfyIds.slice(1));
    } else if (selectedIndex === selectedGiagoimfyIds.length - 1) {
      newSelectedGiagoimfyIds = newSelectedGiagoimfyIds.concat(selectedGiagoimfyIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedGiagoimfyIds = newSelectedGiagoimfyIds.concat(
        selectedGiagoimfyIds.slice(0, selectedIndex),
        selectedGiagoimfyIds.slice(selectedIndex + 1)
      );
    }

    setSelectedGiagoimfyIds(newSelectedGiagoimfyIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, giagoimfy) => {
    setSelected(giagoimfy);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(GiagoimfyAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(GiagoimfyAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Tên gói cước
                </TableCell>
                <TableCell>
                  Phí thu hồi
                </TableCell>
                <TableCell>
                  Giá T1
                </TableCell>
                <TableCell>
                  Giá T2
                </TableCell>
                <TableCell>
                  Giá T3
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.slice(page * limit, page * limit + limit).map((giagoimfy, index) => (
                <TableRow
                  hover
                  key={giagoimfy.id}
                  selected={selectedGiagoimfyIds.indexOf(giagoimfy.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {giagoimfy.ten_goi_cuoc}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {numeral(giagoimfy.phi_thu_hoi).format('0,0')}
                  </TableCell>
                  <TableCell>
                    {numeral(giagoimfy.gia_t1).format('0,0')}
                  </TableCell>
                  <TableCell>
                    {numeral(giagoimfy.gia_t2).format('0,0')}
                  </TableCell>
                  <TableCell>
                    {numeral(giagoimfy.gia_t3).format('0,0')}
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(giagoimfy.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, giagoimfy)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.ten_goi_cuoc} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default GiagoimfyLookupDetail;
